module.exports = __webpack_public_path__ + "media/images/subject_img/ASTROPHYSICS-ASTRONOMY-b7acff41432c049a1add58ed78eef210.jpg";